import { colorTokens } from './color_tokens';
import { darkColorTokens } from './dark_color_tokens';
import { lightColorTokens } from './light_color_tokens';
// @TODO: Extract colors from 'extended' section based on
// customer's plan.
export const getColorPalette = (mode) => ({
    mode,
    // @ts-expect-error We don't need to specify a contrast color
    primary: {
        main: mode === 'light'
            ? lightColorTokens.OV.extended.Proactive.color
            : darkColorTokens.OV.extended.Proactive.color,
        light: lightColorTokens.OV.extended.Proactive.color,
        dark: darkColorTokens.OV.extended.Proactive.color,
    },
    custom: {
        ...colorTokens,
        ...(mode === 'light'
            ? {
                ...lightColorTokens,
            }
            : {
                ...darkColorTokens,
            }),
    },
});
